module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting",
    attrs: {
      "epub:type": "z3998:published-works",
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("ALSO BY ALEX WALTERS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("The DI Alec McKay Series")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Candles and Roses (Book 1)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Death Parts Us (Book 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Their Final Act (Book 3)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Expiry Date (Book 4)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("For Their Sins (Book 5)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("A Parting Gift (Book 6)")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Winterman")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b6404c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-alex-walters.vue
// module id = 72
// module chunks = 0